

export default class DataProvider {
    callbacks = new DataProviderCallback()
    dataLoaded: boolean = false
    counter = 0
    listen(callback: (provider: DataProvider) => void): string {
        const newId = (this.counter++) + ""
        this.callbacks[newId] = callback
        if(this.dataLoaded)
            callback(this)

        return newId
    }

    call(){
        Object.keys(this.callbacks).forEach((key) => this.callbacks[key](this))
    }

    remove(key:string){
        delete this.callbacks[key]
    }

    clearListeners(){
        Object.keys(this.callbacks).forEach((key) => this.remove(key))
    }
}

class DataProviderCallback {
    [index: string]: (provider: DataProvider) => void;
}
